<template>
    <div class="min-h-screen bg-white flex">
        <div class="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
            <div class="mx-auto w-full max-w-sm lg:w-96">
                <templete v-if="!registered">
                    <div class="flex items-center justify-center">
                        <img
                            class="h-12 w-auto"
                            :src="logoUrl"
                            alt="Logo"
                            @error="onLogoError" >
                    </div>

                    <h2 class="mt-3 ml-4 text-center font-extrabold text-main-text dark:text-main-text-dark">
                        Đăng ký tài khoản
                    </h2>
                    <p class="text-center text-gray-500 mt-3">
                        Vui lòng nhập đẩy đủ thông tin
                    </p>

                    <hts-form
                        :rules="rules"
                        class="mt-2"
                        @submit="onSubmit">
                        <div class="flex flex-col gap-1">
                            <!-- Last name -->

                            <hts-form-radio
                                v-model="formData.registerBy"
                                label="Đăng ký bằng"
                                :items="registerByItems"
                                :disabled="disabled"
                                required
                                value-key="key"
                                label-key="label" />

                            <hts-form-input
                                v-model="formData.fullName"
                                :label="$t('labels.fullName')"
                                name="fullName"
                                prop="fullName"
                                required />

                            <!-- Phone -->

                            <hts-form-phone
                                v-if="formData.registerBy === 'phone'"
                                v-model="formData.phone"
                                required
                                :label="$t('labels.phone')"
                                prop="phone"
                                name="phone"
                                :disabled="disabled" />

                            <!-- Email -->

                            <hts-form-input
                                v-if="formData.registerBy === 'email'"
                                v-model="formData.email"
                                :label="$t('labels.email')"
                                name="email"
                                prop="email"
                                required
                                :disabled="disabled" />

                            <!-- Password -->

                            <hts-form-input
                                v-model="formData.password"
                                :label="$t('labels.password')"
                                name="password"
                                prop="password"
                                type="password"
                                required />

                            <!-- Confirm Password -->

                            <hts-form-input
                                v-model="formData.confirmPassword"
                                :label="$t('labels.confirmPassword')"
                                name="confirmPassword"
                                prop="confirmPassword"
                                type="password"
                                required />

                            <hts-form-button
                                v-loading="loading"
                                class="group relative w-full flex justify-center #FFEDD5 mt-3"
                                color="primary"
                                type="submit">
                                <p class="flex items-center justify-center">
                                    <span>
                                        {{ $t('labels.register') }}
                                    </span>
                                    <hi-user-plus-icon class="h-6 w-6 ml-2" />
                                </p>
                            </hts-form-button>

                            <div class="flex justify-center items-center mt-3">
                                <span class="mr-1">
                                    Bạn đã có tài khoản?
                                </span>

                                <hts-link
                                    :to="backUrl && query ? { name: 'auth-login', query } : { name: 'auth-login' }"
                                    class="text-main-500">
                                    {{ $t('labels.login') }}
                                </hts-link>

                                <!--
                                  <router-link
                                  :to="backUrl && backUrl !== 'undefined' ? { name: 'auth-login', query: { backUrl } } : { name: 'auth-login' }"
                                  class="flex font-medium text-main-500 cursor-pointer"
                                  color="main">
                                  {{ $t('labels.login') }}
                                  </router-link>
                                -->
                            </div>

                            <!--
                              <div class="flex justify-between mt-3">
                              <div class="flex justify-center items-center mt-2">
                              <router-link
                              :to="backUrl && backUrl !== 'undefined' ? { name: 'auth-login', query: { backUrl } } : { name: 'auth-login' }"
                              class="flex font-medium text-gray-600 cursor-pointer"
                              color="main">
                              <hi-arrow-small-left-icon class="h-6 w-6 ml-2" />
                              {{ $t('labels.login') }}
                              </router-link>
                              </div>
                              <div class="flex justify-center items-center mt-2"/>
                              </div>
                            -->
                        </div>
                    </hts-form>
                </templete>
                <template v-else>
                    <div>
                        <div class="d-flex flex-row">
                            <h4 class="text-success-400 p-4 border rounded-2xl border-success-500 bg-success-5">
                                Đăng ký tài khoản thành công
                            </h4>
                        </div>

                        <div class="mt-5 flex justify-center">
                            <!--
                              <router-link
                              class="text-main-500">
                              <p class="link">
                              Đăng nhập
                              </p>

                              </router-link>
                            -->

                            <hts-link
                                :to="backUrl && backUrl !== 'undefined' ? { name: 'auth-login', query } : { name: 'auth-login' }"
                                class="text-main-500">
                                {{ $t('labels.login') }}
                            </hts-link>

                            <!--
                              <div class="inline-block ml-5 pl-5">
                              <router-link
                              class="mt-1px flex"
                              to="/auth/register"
                              @click="continueRegister()">
                              <p class="link">
                              Tiếp tục Đăng kí
                              </p>
                              </router-link>
                              </div>
                            -->
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="hidden lg:block relative w-0 flex-1">
            <img
                class="absolute inset-0 h-full w-full object-cover"
                alt=""
                src="https://images.unsplash.com/photo-1505904267569-f02eaeb45a4c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1908&q=80" >
        </div>
    </div>
</template>

<script lang="ts" setup>
import data from '@/pages/trucker-[id]/company/user-group/-components/imports/data'
const { auth } = $store()
const { registerByItems } = data()
const store = $store()
const route = useRoute()

const disabled = ref(false)
const registing = ref(false)
const registered = ref(false)

const query = computed(() => route.query || null)
const backUrl = computed(() => String(route.query.backUrl) || null)
const registerBy = computed(() => String(route.query.registerBy) || null)
const email = computed(() => String(route.query.email) || null)
const phone = computed(() => String(route.query.phone) || null)
const code = computed(() => String(route.query.code) || null)
const countryCode = computed(() => String(route.query.countryCode)?.replace('_', ' ') || null)

definePageMeta({
  layout: 'auth'
})

const rules = computed(() => {
  const r = {
    fullName: 'required|regexName',
    password: 'required|regexPassword|min:6|max:40',
    confirmPassword: 'required|confirmed:@password'
  } as { [key: string]: string }

  if (formData.registerBy === 'email') {
    r.email = 'required|email'
  }
  if (formData.registerBy === 'phone') {
    r.phone = 'required'
  }

  return r
})

const initForm = {
  registerBy: 'email',
  fullName: '',
  email: '' as string | null,
  password: '',
  confirmPassword: '',
  phone: {
    countryCode: 'Vietnam +84',
    phone: '',
    code: '+84'
  } as { [key: string]: string } | null
}

const formData = reactive({ ...initForm })

onMounted(() => {
  if (registerBy.value && registerBy.value !== 'undefined') {
    formData.registerBy = registerBy.value
  }

  if (email.value && email.value !== 'undefined') {
    formData.email = email.value
    disabled.value = true
  }

  if (phone.value && phone.value !== 'undefined' && code.value && code.value !== 'undefined' && countryCode.value && countryCode.value !== 'undefined') {
    formData.phone = {}
    formData.phone.phone = phone.value
    formData.phone.code = code.value
    formData.phone.countryCode = countryCode.value
    disabled.value = true
  }
})

const continueRegister = () => {
  registered.value = false
  Object.assign(formData, { ...initForm })
  disabled.value = false
}
const loading = ref(false)
// const api = reactive({
//   uri: '',
//   method: 'post'
// })
/**
 * Action register new account
 * @returns {Promise<void>}
 */

const onSubmit = $lodash.debounce(async () => {
  registing.value = true
  const api = $url.auth.register

  if (formData.registerBy === 'email') {
    formData.phone = null
  }

  if (formData.registerBy === 'phone') {
    formData.email = null
  }

  const res = await $api(api, { body: formData })
  const data: any = res?.data.value
  if (data?.success) {
    registered.value = true
  }

  registing.value = false
}, 300)

const logoUrl = computed(() => {
  const defaultLogoUrl = '/assets/logo.png'
  return defaultLogoUrl
})

const onLogoError = (event: Event) => {
  const target = event.target as HTMLImageElement
  target.style.display = 'none'
}

// const login = async () => {
//   const config = useRuntimeConfig().public
//   const dataForm = {
//     username: formData.email,
//     password: formData.password,
//     client_id: config.clientId,
//     client_secret: config.clientSecret,
//     grant_type: 'password'
//   }
//   const res = await $api($url.auth.login, { body: new URLSearchParams(dataForm) })
//   const data: any = res?.data?.value || {}
//   if (data) {
//     const dataToken = data?.data || {} // data access token
//     const token = $lodash.get(dataToken, 'access_token', '')
//     const expiresIn = $lodash.get(dataToken, 'expires_in', '')
//     const refreshToken = $lodash.get(dataToken, 'refresh_token', '')
//     const workspaces = $lodash.get(dataToken, 'workspaces', [])
//     const isAdmin = $lodash.get(dataToken, 'isAdmin')
//     const companyTypes = $lodash.get(data, 'companyTypes', [])

//     store.userConfig.workspaces = workspaces
//     store.userConfig.isAdmin = isAdmin
//     store.userConfig.companyTypes = companyTypes

//     auth.setAccessToken(token)
//     auth.setRefreshToken(refreshToken)
//     auth.setExpires(expiresIn)

//     if (backUrl.value && backUrl.value !== 'undefined') {
//       if (tokenInvite.value) {
//         navigateTo(backUrl.value + `&token=${tokenInvite.value}`)
//       } else {
//         navigateTo(backUrl.value)
//       }
//     }

//     if (isAdmin) {
//       nextTick(() => {
//         useRouter().push({
//           name: 'admincp'
//         })
//       })
//       return
//     }

//     if (Array.isArray(workspaces) && workspaces.length) {
//       const workspaceId = workspaces[0]._sid
//       auth.setWorkspaceId(workspaceId)

//       if (companyTypes.includes('OWNER')) {
//         return useRouter().push({
//           name: 'trucker-id-dashboard',
//           params: { id: workspaceId }
//         })
//       }
//       if (companyTypes.includes('PARTNER')) {
//         return useRouter().push({
//           name: 'pp-id',
//           params: { id: workspaceId }
//         })
//       }
//       return useRouter().push({
//         name: 'workspace-list'
//       })
//     }
//   }
// }

onMounted(() => {
  // try {
  //   const type: string| null = String(route.query.type) || null
  //
  //   if (!type) {
  //     throw new Error($t('labels.invalidPath'))
  //   }
  //   const api: any = $lodash.get($url, `${type}.checkInvitation`)
  //
  //   if (api) {
  //     api.headers.tokenInvite = token
  //
  //     $api(api)
  //       .then((data) => {
  //         const resError: any = data?.error
  //
  //         if (resError && resError.value) {
  //           navigateTo('/auth/login')
  //         }
  //       })
  //       .catch(() => {
  //         navigateTo('/auth/login')
  //       })
  //   } else {
  //     throw new Error($t('labels.invalidPath'))
  //   }
  // } catch (e: any) {
  //   process.client && $toast().error($t(e.message || e))
  // }
})
</script>
